import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import styles from './setup-fee.module.scss.js';
import { clsx } from '../../external/clsx/dist/clsx.js';
import { Typography, ErrorBoundary } from '@vp/swan';
import { PriceInternal } from '../price/price.component.js';
import { useLocalization } from '../../hooks/useLocalizations.js';

const SetupFeeInternal = forwardRef((props, ref) => {
  const { className, priceContext, setupFee, discountedSetupFee, placeholdertext, ...rest } = props;
  const classNames = clsx(className, styles.setupFee);
  const { t } = useLocalization(priceContext.locale);
  if (!setupFee) {
    return /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "subtle", className: classNames, ...rest, ref, children: t("noSetupFee") });
  }
  return /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "subtle", className: classNames, ...rest, ref, children: t("setupFee", {
    setupFee: /* @__PURE__ */ jsx(
      PriceInternal,
      {
        placeholdertext,
        priceConfig: {
          ...priceContext,
          listPrice: setupFee,
          discountedListPrice: discountedSetupFee
        }
      }
    )
  }) });
});
const SetupFee = forwardRef((props, ref) => {
  return /* @__PURE__ */ jsx(
    ErrorBoundary,
    {
      fallback: /* @__PURE__ */ jsx(Typography, { as: "span", fontSkin: "body-small", textColor: "subtle", children: props.placeholdertext }),
      children: /* @__PURE__ */ jsx(SetupFeeInternal, { ...props, ref })
    }
  );
});

export { SetupFee, SetupFeeInternal };
